module.exports = __webpack_public_path__ + "65d69878ef1e16946f974c40267e4d30.svg";